export default {
    getList: {
        getNoticeList: async function (params) {
            let option = {
                url: '/api/v1/user/rules',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/user/site' + '/' + params.site_id,
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}